<template>
  <div>
    <el-alert
      title="按已受理工艺的工序投料汇总；没有投料时展开产品结构叶子。现存量取可用库存，缺料为需求减现存量。切换替代料会按替代料重算。覆盖分析、供应建议在后续菜单。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-input v-model="query.requirementCode" clearable placeholder="需求单号" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.orderCode" clearable placeholder="工单编号" style="width:160px" @keyup.enter.native="search" />
      <el-select v-model="query.reqState" clearable placeholder="状态" style="width:120px">
        <el-option label="草稿" value="00" />
        <el-option label="已确认" value="01" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="success" plain icon="el-icon-document-add" @click="openMerge">多工单合并生成</el-button>
    </div>

    <el-table :data="list" border v-loading="loading">
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="requirementCode" label="需求单号" min-width="180" show-overflow-tooltip/>
      <el-table-column prop="orderCode" label="主工单" min-width="180" show-overflow-tooltip/>
      <el-table-column label="合并工单" min-width="180" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span v-if="row.sourceOrderCodes">{{ row.sourceOrderCodes }}</span>
          <span v-else>{{ row.orderName || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="bomVersion" label="工艺编码" width="160" show-overflow-tooltip />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="row.reqState === '01' ? 'success' : 'info'">{{ row.reqState === '01' ? '已确认' : '草稿' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="240" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openDetail(row.requirementId)">明细</el-button>
          <el-button type="text" :disabled="row.reqState !== '00'" @click="confirmRow(row.requirementId)">确认</el-button>
          <el-button type="text" :disabled="row.reqState !== '01'" @click="unconfirmRow(row.requirementId)">反确认</el-button>
          <el-button type="text" style="color:#ef4444" :disabled="row.reqState !== '00'" @click="onDelete(row.requirementId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage" @size-change="onSize"
    />

    <el-dialog title="物料需求明细" :visible.sync="detailVisible" width="980px">
      <el-alert v-if="detail && detail.sourceOrderCodes" :title="'合并工单：' + detail.sourceOrderCodes" type="info" :closable="false" style="margin-bottom:10px" />
      <div v-if="detail" style="margin-bottom:10px">
        <el-button type="success" plain size="small" :disabled="!!detail.supplySuggestionCode" @click="genSupply">生成供应建议</el-button>
      </div>
      <el-table v-if="detail" :data="detail.lines || []" border size="small">
        <el-table-column prop="productNumber" label="主料编码" width="120" />
        <el-table-column prop="productName" label="主料名称" min-width="120" />
        <el-table-column prop="substituteProductName" label="替代料" min-width="120" />
        <el-table-column label="使用替代" width="110" align="center">
          <template slot-scope="{ row }">
            <el-switch
              v-if="detail.reqState === '00' && row.substituteProductId"
              :value="row.useSubstitute === '1'"
              active-text="是"
              inactive-text="否"
              @change="v => toggleSubstitute(row, v)"
            />
            <span v-else>{{ row.useSubstitute === '1' ? '是' : '否' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="requiredQty" label="需求数量" width="120" align="right" />
        <el-table-column prop="stockQty" label="可用库存" width="110" align="right" />
        <el-table-column label="缺料数量" width="110" align="right">
          <template slot-scope="{ row }">
            <span :style="{ color: Number(row.shortageQty) > 0 ? '#F56C6C' : '' }">{{ row.shortageQty }}</span>
          </template>
        </el-table-column>
        <el-table-column label="单位" width="80" align="center">
          <template slot-scope="{ row }">{{ unitLabel(row.unit) }}</template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="多工单合并生成物料需求" :visible.sync="mergeVisible" width="640px" :close-on-click-modal="false">
      <el-alert title="按产品汇总多张工单的投料或结构需求，生成一张草稿。已确认的需求不能覆盖。" type="info" :closable="false" show-icon style="margin-bottom:12px" />
      <el-select v-model="mergeOrderIds" multiple filterable clearable placeholder="选择工单（可多选）" style="width:100%" :loading="orderLoading">
        <el-option
          v-for="o in orderOptions"
          :key="o.orderId"
          :label="(o.orderCode || '') + ' / ' + (o.orderName || '')"
          :value="o.orderId"
        />
      </el-select>
      <span slot="footer">
        <el-button @click="mergeVisible = false">取消</el-button>
        <el-button type="primary" :loading="mergeLoading" @click="doMerge">生成</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listMaterialRequirement,
  getMaterialRequirement,
  generateMaterialRequirement,
  confirmMaterialRequirement,
  unconfirmMaterialRequirement,
  setMaterialRequirementUseSubstitute,
  deleteMaterialRequirement
} from '../../api/materialRequirement'
import { listProductionOrder } from '../../api/productionOrder'
import { generateSupplySuggestionFromRequirement } from '../../api/supplySuggestion'
import { listDictOptions } from '../../api/dict'

export default {
  components: { ListPagination },
  data() {
    return {
      query: { requirementCode: '', orderCode: '', reqState: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false,
      detailVisible: false, detail: null, units: [],
      mergeVisible: false, mergeOrderIds: [], orderOptions: [], orderLoading: false, mergeLoading: false
    }
  },
  created() {
    this.load()
    listDictOptions('UNIT').then(res => { this.units = res.data || [] }).catch(() => {})
  },
  methods: {
    unitLabel(code) {
      if (!code) return ''
      const hit = this.units.find(u => String(u.id) === String(code) || u.dictValue === code || u.dictLabel === code)
      return hit ? hit.dictLabel : code
    },
    indexMethod(i) { return (this.page - 1) * this.pageSize + i + 1 },
    flattenProductionOrders(rows) {
      const out = []
      const walk = list => {
        (list || []).forEach(row => {
          out.push(row)
          if (row.children && row.children.length) walk(row.children)
        })
      }
      walk(rows)
      return out
    },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listMaterialRequirement({
        currentPage: this.page, pageSize: this.pageSize,
        requirementCode: this.query.requirementCode,
        orderCode: this.query.orderCode,
        reqState: this.query.reqState
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openDetail(id) {
      getMaterialRequirement(id).then(res => {
        this.detail = res.data
        this.detailVisible = true
      })
    },
    openMerge() {
      this.mergeOrderIds = []
      this.mergeVisible = true
      this.orderLoading = true
      listProductionOrder({ currentPage: 1, pageSize: 500 }).then(res => {
        const list = this.flattenProductionOrders((res.data && res.data.list) || [])
        this.orderOptions = list.filter(o => o.orderState === '01' || o.orderState === '02' || o.orderState === '05')
      }).finally(() => { this.orderLoading = false })
    },
    doMerge() {
      if (!this.mergeOrderIds.length) {
        this.$message.warning('请至少选择一张工单')
        return
      }
      const tip = this.mergeOrderIds.length > 1
        ? '将合并 ' + this.mergeOrderIds.length + ' 张工单按产品汇总生成一张物料需求草稿，继续？'
        : '将生成物料需求草稿，继续？'
      this.$confirm(tip, '提示', { type: 'warning' }).then(() => {
        this.mergeLoading = true
        generateMaterialRequirement(this.mergeOrderIds).then(() => {
          this.$message.success('已生成')
          this.mergeVisible = false
          this.search()
        }).finally(() => { this.mergeLoading = false })
      }).catch(() => {})
    },
    toggleSubstitute(row, use) {
      setMaterialRequirementUseSubstitute(row.requirementLineId, use).then(() => {
        this.$message.success('已更新')
        this.openDetail(this.detail.requirementId)
      })
    },
    genSupply() {
      if (!this.detail || !this.detail.requirementId) return
      this.$confirm('将按本需求（含多工单合并）缺料生成供应建议草稿，继续？', '提示', { type: 'warning' }).then(() => {
        generateSupplySuggestionFromRequirement(this.detail.requirementId).then(res => {
          const code = res.data && res.data.suggestionCode
          this.$message.success(code ? ('已生成供应建议 ' + code) : '已生成供应建议')
          this.detailVisible = false
        })
      }).catch(() => {})
    },
    confirmRow(id) {
      this.$confirm('确认后开工齐套按这份需求计算。需要改数量或替代料时，先反确认退回草稿。', '提示', { type: 'warning' }).then(() => {
        confirmMaterialRequirement(id).then(() => {
          this.$message.success('操作成功')
          this.load()
        })
      }).catch(() => {})
    },
    unconfirmRow(id) {
      this.$confirm('反确认后将退回草稿，可切换替代料、重新生成或删除。', '提示', { type: 'warning' }).then(() => {
        unconfirmMaterialRequirement(id).then(() => {
          this.$message.success('已反确认')
          this.load()
        })
      }).catch(() => {})
    },
    onDelete(id) {
      this.$confirm('确定删除？', '提示', { type: 'warning' }).then(() => {
        deleteMaterialRequirement([id]).then(() => {
          this.$message.success('操作成功')
          this.load()
        })
      }).catch(() => {})
    }
  }
}
</script>
